import Icon from '../components/Icon.vue'

Icon.register({
  'umbrella-beach': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M115.4 136.9c-10.1-3.7-14.1-16.3-7.4-24.7 59.8-74.8 152.7-116.7 248.5-111.8-52.8 29.4-103.8 92.2-139 173.7zM247.6 185.1c44.5-102 114.7-171.1 172.8-171.1 8 0 15.7 1.3 23.1 4 61.3 22.3 78.4 132.6 42.6 254zM521.5 60.5c76.5 57.9 120.8 149.7 118.4 245.4-0.3 10.7-11.5 17.8-21.6 14.2l-102.6-37.4c17.5-58.8 24.7-117.1 18.9-167-2.4-20.6-7-38.9-13.2-55.2zM560 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-544c-8.8 0-16-7.2-16-16v-32c0-8.9 7.2-16 16-16h237l72.9-200.4 60.1 21.9-64.9 178.5h238.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/umbrella-beach.js
// module id = 2045
// module chunks = 0